export default class FieldObject {
  constructor (cxt, name, type, ref, fieldValue, def) {
    this.cxt = cxt
    this.name = name
    this.type = type
    this.ref = ref
    this.fieldValue = fieldValue
    this.def = def
  }
  getCode (model) {
    return model[this.name] ? model[this.name] + '' : null
  }
  setCode (model, newCode, onChange) {
    this.setValue(model, newCode, null, onChange)
  }
  getValue (model) {
    return model[this.name]
  }
  setValue (model, newCode, newObject, onChange) {
    // console.log('FieldObject.setValue', newCode, newObject)
    if (!this.equalCode(model, newCode)) {
      onChange && onChange(model, this.name, newCode)
      model[this.name] = newCode
    }
  }
  equalCode (model, value) {
//    console.log('FieldObject.equalCode', this.name, value, (!!this.getCode(model)) && (!!value) && (this.getCode(model) === value))
    return (!!this.getCode(model)) && (!!value) && (this.getCode(model) === value)
  }
  init (model) {
    this.setValue(model, null)
  }
  initDescription (model) {
  }
  getDescription (model) {
    return ''
  }
  getHint (model) {
    return model[this.name]
  }
  clearRef (model) {
    var refs = this.cxt.refMap.get(this.name)
    if (refs) {
      refs.forEach(r => {
        let fobj = this.cxt.fieldObjects.get(r)
        fobj.init(model)
        fobj.clearRef(model)
      })
    }
  }
  fillRef (model, data, onChange) {
  }
}



// WEBPACK FOOTER //
// ./src/components/assist/fields/FieldObject.js